<div *ngFor="let link; og: alert?.links" class="cssAlert">
  <span [innerHTML]="alert.message"></span>
</div>
